/* eslint-disable no-nested-ternary */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../../lib/PropTypes';
import { getImageAtSize } from '../../../lib/utils';

import { useThemeClassName } from '../../../contexts/ThemeContext';

import styles from '../../../../styles/items/bonus-card.module.scss';

const propTypes = {
    handle: PropTypes.string,
    image: AppPropTypes.image,
    title: PropTypes.string,
    description: PropTypes.string,
    participations: PropTypes.number,
    completed: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    imageClassName: PropTypes.string,
};

const defaultProps = {
    handle: null,
    image: null,
    title: null,
    description: null,
    participations: null,
    completed: false,
    children: null,
    className: null,
    imageClassName: null,
};

function DefaultBonusCard({
    handle,
    image,
    title,
    description,
    participations,
    completed,
    children,
    className,
    imageClassName,
}) {
    const themeClassName = useThemeClassName(styles);
    const { url: imageUrl, alt: imageAlt } = getImageAtSize(image, 'medium', false) || {};
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.completed]: completed,
                },
                styles[handle],
                themeClassName,
                className,
            ])}
        >
            <div className={styles.inner}>
                {imageUrl !== null ? (
                    <img
                        src={imageUrl}
                        alt={imageAlt}
                        className={classNames([styles.image, imageClassName])}
                    />
                ) : null}
                {title !== null ? <h4 className={styles.title}>{title}</h4> : null}
                {participations !== null ? (
                    <div className={styles.participations}>
                        <FormattedMessage
                            defaultMessage="+ {count, plural, =0 {# participation} one {# participation} other {# participations}}"
                            description="Bonus label"
                            values={{
                                count: participations,
                            }}
                        />
                    </div>
                ) : null}
                {description !== null ? (
                    <div
                        className={styles.title}
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                ) : null}
                {children}
            </div>
        </div>
    );
}

DefaultBonusCard.propTypes = propTypes;
DefaultBonusCard.defaultProps = defaultProps;

export default DefaultBonusCard;
